import React, { Fragment } from "react"

import { Button, Spinner } from "components"
import CdsamAddressCard from "./CdsamAddressCard"
import CdsamAddressesFooter from "./CdsamAddressesFooter"
import classes from "./index.module.scss"

const CdsamAddresses = (props) => {
  const {
    setModalContent,
    userAddresses,
    setUserAddresses,
    selectedAddress,
    setSelectedAddress,
    setAddressForEdit,
    setOpenMapAddressModal,
    selectedUserAccount
  } = props

  return (
    <Fragment>
      <div className={classes["title"]}>
        آدرس های کاربر
      </div>

      {userAddresses !== null
        ?
        <Fragment>
          <div className={classes["header"]}>
            <Button
              color="success"
              onClick={() => setModalContent("form")}
            >
              + افزودن آدرس
            </Button>
          </div>
          {userAddresses.length > 0
            ?
            userAddresses.map(userAddress =>
              <CdsamAddressCard
                key={userAddress._id}
                setModalContent={setModalContent}
                userAddress={userAddress}
                setUserAddresses={setUserAddresses}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                setAddressForEdit={setAddressForEdit}
                selectedUserAccount={selectedUserAccount}
              />
            )
            :
            <div className={classes["centered"]}>
              آدرسی یافت نشد
            </div>
          }
        </Fragment>
        :
        <div className={classes["centered"]}>
          <Spinner
            color="var(--color-primary)"
            size={20}
          />
        </div>
      }

      <CdsamAddressesFooter
        selectedAddress={selectedAddress}
        setOpenMapAddressModal={setOpenMapAddressModal}
      />
    </Fragment>

  )
}

export default CdsamAddresses